import { c as createCommonjsModule, a as commonjsGlobal } from '../common/_commonjsHelpers-37fa8da4.js';
import { q as qe } from '../common/styled-components.browser.esm-159f0df6.js';
import '../common/process-2545f00a.js';
import '../common/index-19deb36c.js';
import '../common/index-ec48241a.js';
import '../common/hoist-non-react-statics.cjs-ed5b3fa8.js';

var a11yDialog = createCommonjsModule(function (module) {

(function (global) {

  var FOCUSABLE_ELEMENTS = ['a[href]:not([tabindex^="-"]):not([inert])', 'area[href]:not([tabindex^="-"]):not([inert])', 'input:not([disabled]):not([inert])', 'select:not([disabled]):not([inert])', 'textarea:not([disabled]):not([inert])', 'button:not([disabled]):not([inert])', 'iframe:not([tabindex^="-"]):not([inert])', 'audio:not([tabindex^="-"]):not([inert])', 'video:not([tabindex^="-"]):not([inert])', '[contenteditable]:not([tabindex^="-"]):not([inert])', '[tabindex]:not([tabindex^="-"]):not([inert])'];
  var TAB_KEY = 9;
  var ESCAPE_KEY = 27;
  var focusedBeforeDialog;
  /**
   * Define the constructor to instantiate a dialog
   *
   * @constructor
   * @param {Element} node
   * @param {(NodeList | Element | string)} targets
   */

  function A11yDialog(node, targets) {
    // Prebind the functions that will be bound in addEventListener and
    // removeEventListener to avoid losing references
    this._show = this.show.bind(this);
    this._hide = this.hide.bind(this);
    this._maintainFocus = this._maintainFocus.bind(this);
    this._bindKeypress = this._bindKeypress.bind(this); // Keep a reference of the node and the actual dialog on the instance

    this.container = node;
    this.dialog = node.querySelector('dialog, [role="dialog"], [role="alertdialog"]');
    this.role = this.dialog.getAttribute('role') || 'dialog';
    this.useDialog = 'show' in document.createElement('dialog') && this.dialog.nodeName === 'DIALOG'; // Keep an object of listener types mapped to callback functions

    this._listeners = {}; // Initialise everything needed for the dialog to work properly

    this.create(targets);
  }
  /**
   * Set up everything necessary for the dialog to be functioning
   *
   * @param {(NodeList | Element | string)} targets
   * @return {this}
   */


  A11yDialog.prototype.create = function (targets) {
    // Keep a collection of nodes to disable/enable when toggling the dialog
    this._targets = this._targets || collect(targets) || getSiblings(this.container); // Set the `shown` property to match the status from the DOM

    this.shown = this.dialog.hasAttribute('open'); // Despite using a `<dialog>` element, `role="dialog"` is not necessarily
    // implied by all screen-readers (yet)
    // See: https://github.com/edenspiekermann/a11y-dialog/commit/6ba711a777aed0dbda0719a18a02f742098c64d9#commitcomment-28694166

    this.dialog.setAttribute('role', this.role);

    if (!this.useDialog) {
      if (this.shown) {
        this.container.removeAttribute('aria-hidden');
      } else {
        this.container.setAttribute('aria-hidden', true);
      }
    } else {
      this.container.setAttribute('data-a11y-dialog-native', ''); // Remove initial `aria-hidden` from container
      // See: https://github.com/edenspiekermann/a11y-dialog/pull/117#issuecomment-706056246

      this.container.removeAttribute('aria-hidden');
    } // Keep a collection of dialog openers, each of which will be bound a click
    // event listener to open the dialog


    this._openers = $$('[data-a11y-dialog-show="' + this.container.id + '"]');

    this._openers.forEach(function (opener) {
      opener.addEventListener('click', this._show);
    }.bind(this)); // Keep a collection of dialog closers, each of which will be bound a click
    // event listener to close the dialog


    this._closers = $$('[data-a11y-dialog-hide]', this.container).concat($$('[data-a11y-dialog-hide="' + this.container.id + '"]'));

    this._closers.forEach(function (closer) {
      closer.addEventListener('click', this._hide);
    }.bind(this)); // Execute all callbacks registered for the `create` event


    this._fire('create');

    return this;
  };
  /**
   * Show the dialog element, disable all the targets (siblings), trap the
   * current focus within it, listen for some specific key presses and fire all
   * registered callbacks for `show` event
   *
   * @param {Event} event
   * @return {this}
   */


  A11yDialog.prototype.show = function (event) {
    // If the dialog is already open, abort
    if (this.shown) {
      return this;
    }

    this.shown = true; // Keep a reference to the currently focused element to be able to restore
    // it later

    focusedBeforeDialog = document.activeElement;

    if (this.useDialog) {
      this.dialog.showModal(event instanceof Event ? void 0 : event);
    } else {
      this.dialog.setAttribute('open', '');
      this.container.removeAttribute('aria-hidden'); // Iterate over the targets to disable them by setting their `aria-hidden`
      // attribute to `true` and, if present, storing the current value of `aria-hidden`

      this._targets.forEach(function (target) {
        if (target.hasAttribute('aria-hidden')) {
          target.setAttribute('data-a11y-dialog-original-aria-hidden', target.getAttribute('aria-hidden'));
        }

        target.setAttribute('aria-hidden', 'true');
      });
    } // Set the focus to the first focusable child of the dialog element


    setFocusToFirstItem(this.dialog); // Bind a focus event listener to the body element to make sure the focus
    // stays trapped inside the dialog while open, and start listening for some
    // specific key presses (TAB and ESC)

    document.body.addEventListener('focus', this._maintainFocus, true);
    document.addEventListener('keydown', this._bindKeypress); // Execute all callbacks registered for the `show` event

    this._fire('show', event);

    return this;
  };
  /**
   * Hide the dialog element, enable all the targets (siblings), restore the
   * focus to the previously active element, stop listening for some specific
   * key presses and fire all registered callbacks for `hide` event
   *
   * @param {Event} event
   * @return {this}
   */


  A11yDialog.prototype.hide = function (event) {
    // If the dialog is already closed, abort
    if (!this.shown) {
      return this;
    }

    this.shown = false;

    if (this.useDialog) {
      this.dialog.close(event instanceof Event ? void 0 : event);
    } else {
      this.dialog.removeAttribute('open');
      this.container.setAttribute('aria-hidden', 'true'); // Iterate over the targets to enable them by removing their `aria-hidden`
      // attribute or resetting it to its original value

      this._targets.forEach(function (target) {
        if (target.hasAttribute('data-a11y-dialog-original-aria-hidden')) {
          target.setAttribute('aria-hidden', target.getAttribute('data-a11y-dialog-original-aria-hidden'));
          target.removeAttribute('data-a11y-dialog-original-aria-hidden');
        } else {
          target.removeAttribute('aria-hidden');
        }
      });
    } // If there was a focused element before the dialog was opened (and it has a
    // `focus` method), restore the focus back to it
    // See: https://github.com/edenspiekermann/a11y-dialog/issues/108


    if (focusedBeforeDialog && focusedBeforeDialog.focus) {
      focusedBeforeDialog.focus();
    } // Remove the focus event listener to the body element and stop listening
    // for specific key presses


    document.body.removeEventListener('focus', this._maintainFocus, true);
    document.removeEventListener('keydown', this._bindKeypress); // Execute all callbacks registered for the `hide` event

    this._fire('hide', event);

    return this;
  };
  /**
   * Destroy the current instance (after making sure the dialog has been hidden)
   * and remove all associated listeners from dialog openers and closers
   *
   * @return {this}
   */


  A11yDialog.prototype.destroy = function () {
    // Hide the dialog to avoid destroying an open instance
    this.hide(); // Remove the click event listener from all dialog openers

    this._openers.forEach(function (opener) {
      opener.removeEventListener('click', this._show);
    }.bind(this)); // Remove the click event listener from all dialog closers


    this._closers.forEach(function (closer) {
      closer.removeEventListener('click', this._hide);
    }.bind(this)); // Execute all callbacks registered for the `destroy` event


    this._fire('destroy'); // Keep an object of listener types mapped to callback functions


    this._listeners = {};
    return this;
  };
  /**
   * Register a new callback for the given event type
   *
   * @param {string} type
   * @param {Function} handler
   */


  A11yDialog.prototype.on = function (type, handler) {
    if (typeof this._listeners[type] === 'undefined') {
      this._listeners[type] = [];
    }

    this._listeners[type].push(handler);

    return this;
  };
  /**
   * Unregister an existing callback for the given event type
   *
   * @param {string} type
   * @param {Function} handler
   */


  A11yDialog.prototype.off = function (type, handler) {
    var index = this._listeners[type].indexOf(handler);

    if (index > -1) {
      this._listeners[type].splice(index, 1);
    }

    return this;
  };
  /**
   * Iterate over all registered handlers for given type and call them all with
   * the dialog element as first argument, event as second argument (if any).
   *
   * @access private
   * @param {string} type
   * @param {Event} event
   */


  A11yDialog.prototype._fire = function (type, event) {
    var listeners = this._listeners[type] || [];
    listeners.forEach(function (listener) {
      listener(this.container, event);
    }.bind(this));
  };
  /**
   * Private event handler used when listening to some specific key presses
   * (namely ESCAPE and TAB)
   *
   * @access private
   * @param {Event} event
   */


  A11yDialog.prototype._bindKeypress = function (event) {
    // If the dialog is shown and the ESCAPE key is being pressed, prevent any
    // further effects from the ESCAPE key and hide the dialog, unless its role
    // is 'alertdialog', which should be modal
    if (this.shown && event.which === ESCAPE_KEY && this.role !== 'alertdialog') {
      event.preventDefault();
      this.hide(event);
    } // If the dialog is shown and the TAB key is being pressed, make sure the
    // focus stays trapped within the dialog element


    if (this.shown && event.which === TAB_KEY) {
      trapTabKey(this.dialog, event);
    }
  };
  /**
   * Private event handler used when making sure the focus stays within the
   * currently open dialog
   *
   * @access private
   * @param {Event} event
   */


  A11yDialog.prototype._maintainFocus = function (event) {
    // If the dialog is shown and the focus is not within the dialog element,
    // move it back to its first focusable child
    if (this.shown && !this.container.contains(event.target)) {
      setFocusToFirstItem(this.dialog);
    }
  };
  /**
   * Convert a NodeList into an array
   *
   * @param {NodeList} collection
   * @return {Array<Element>}
   */


  function toArray(collection) {
    return Array.prototype.slice.call(collection);
  }
  /**
   * Query the DOM for nodes matching the given selector, scoped to context (or
   * the whole document)
   *
   * @param {String} selector
   * @param {Element} [context = document]
   * @return {Array<Element>}
   */


  function $$(selector, context) {
    return toArray((context || document).querySelectorAll(selector));
  }
  /**
   * Return an array of Element based on given argument (NodeList, Element or
   * string representing a selector)
   *
   * @param {(NodeList | Element | string)} target
   * @return {Array<Element>}
   */


  function collect(target) {
    if (NodeList.prototype.isPrototypeOf(target)) {
      return toArray(target);
    }

    if (Element.prototype.isPrototypeOf(target)) {
      return [target];
    }

    if (typeof target === 'string') {
      return $$(target);
    }
  }
  /**
   * Set the focus to the first element with `autofocus` or the first focusable
   * child of the given element
   *
   * @param {Element} node
   */


  function setFocusToFirstItem(node) {
    var focusableChildren = getFocusableChildren(node);
    var focused = node.querySelector('[autofocus]') || focusableChildren[0];

    if (focused) {
      focused.focus();
    }
  }
  /**
   * Get the focusable children of the given element
   *
   * @param {Element} node
   * @return {Array<Element>}
   */


  function getFocusableChildren(node) {
    return $$(FOCUSABLE_ELEMENTS.join(','), node).filter(function (child) {
      return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
    });
  }
  /**
   * Trap the focus inside the given element
   *
   * @param {Element} node
   * @param {Event} event
   */


  function trapTabKey(node, event) {
    var focusableChildren = getFocusableChildren(node);
    var focusedItemIndex = focusableChildren.indexOf(document.activeElement); // If the SHIFT key is being pressed while tabbing (moving backwards) and
    // the currently focused item is the first one, move the focus to the last
    // focusable item from the dialog element

    if (event.shiftKey && focusedItemIndex === 0) {
      focusableChildren[focusableChildren.length - 1].focus();
      event.preventDefault(); // If the SHIFT key is not being pressed (moving forwards) and the currently
      // focused item is the last one, move the focus to the first focusable item
      // from the dialog element
    } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
      focusableChildren[0].focus();
      event.preventDefault();
    }
  }
  /**
   * Retrieve siblings from given element
   *
   * @param {Element} node
   * @return {Array<Element>}
   */


  function getSiblings(node) {
    var nodes = toArray(node.parentNode.childNodes);
    var siblings = nodes.filter(function (node) {
      return node.nodeType === 1;
    });
    siblings.splice(siblings.indexOf(node), 1);
    return siblings;
  }

  function instantiateDialogs() {
    $$('[data-a11y-dialog]').forEach(function (node) {
      new A11yDialog(node, node.getAttribute('data-a11y-dialog') || undefined);
    });
  }

  if (typeof global.document !== 'undefined') {
    var document = global.document;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', instantiateDialogs);
    } else {
      if (global.requestAnimationFrame) {
        global.requestAnimationFrame(instantiateDialogs);
      } else {
        global.setTimeout(instantiateDialogs, 16);
      }
    }
  }

  {
    module.exports = A11yDialog;
  }
})(typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : window);
});

function n() {
  return (n = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }

    return e;
  }).apply(this, arguments);
}

function r(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, o(e, t);
}

function o(e, t) {
  return (o = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function a(e, t) {
  if (null == e) return {};
  var n,
      r,
      o = {},
      a = Object.keys(e);

  for (r = 0; r < a.length; r++) t.indexOf(n = a[r]) >= 0 || (o[n] = e[n]);

  return o;
}

function i(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}

function u(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}

var c = Object.getOwnPropertySymbols,
    s = Object.prototype.hasOwnProperty,
    l = Object.prototype.propertyIsEnumerable;

function f(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var p = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, t) {
  for (var n, r, o = f(e), a = 1; a < arguments.length; a++) {
    for (var i in n = Object(arguments[a])) s.call(n, i) && (o[i] = n[i]);

    if (c) {
      r = c(n);

      for (var u = 0; u < r.length; u++) l.call(n, r[u]) && (o[r[u]] = n[r[u]]);
    }
  }

  return o;
},
    d = u(function (e, t) {
  var n = 60103,
      r = 60106;
  t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
  var o = 60109,
      a = 60110,
      i = 60112;
  t.Suspense = 60113;
  var u = 60115,
      c = 60116;

  if ("function" == typeof Symbol && Symbol.for) {
    var s = Symbol.for;
    n = s("react.element"), r = s("react.portal"), t.Fragment = s("react.fragment"), t.StrictMode = s("react.strict_mode"), t.Profiler = s("react.profiler"), o = s("react.provider"), a = s("react.context"), i = s("react.forward_ref"), t.Suspense = s("react.suspense"), u = s("react.memo"), c = s("react.lazy");
  }

  var l = "function" == typeof Symbol && Symbol.iterator;

  function f(e) {
    for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);

    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  var d = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  },
      y = {};

  function m(e, t, n) {
    this.props = e, this.context = t, this.refs = y, this.updater = n || d;
  }

  function g() {}

  function h(e, t, n) {
    this.props = e, this.context = t, this.refs = y, this.updater = n || d;
  }

  m.prototype.isReactComponent = {}, m.prototype.setState = function (e, t) {
    if ("object" != typeof e && "function" != typeof e && null != e) throw Error(f(85));
    this.updater.enqueueSetState(this, e, t, "setState");
  }, m.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, g.prototype = m.prototype;
  var v = h.prototype = new g();
  v.constructor = h, p(v, m.prototype), v.isPureReactComponent = !0;
  var b = {
    current: null
  },
      j = Object.prototype.hasOwnProperty,
      M = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function w(e, t, r) {
    var o,
        a = {},
        i = null,
        u = null;
    if (null != t) for (o in void 0 !== t.ref && (u = t.ref), void 0 !== t.key && (i = "" + t.key), t) j.call(t, o) && !M.hasOwnProperty(o) && (a[o] = t[o]);
    var c = arguments.length - 2;
    if (1 === c) a.children = r;else if (1 < c) {
      for (var s = Array(c), l = 0; l < c; l++) s[l] = arguments[l + 2];

      a.children = s;
    }
    if (e && e.defaultProps) for (o in c = e.defaultProps) void 0 === a[o] && (a[o] = c[o]);
    return {
      $$typeof: n,
      type: e,
      key: i,
      ref: u,
      props: a,
      _owner: b.current
    };
  }

  function C(e) {
    return "object" == typeof e && null !== e && e.$$typeof === n;
  }

  var x = /\/+/g;

  function L(e, t) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var t = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + e.replace(/[=:]/g, function (e) {
        return t[e];
      });
    }("" + e.key) : t.toString(36);
  }

  function k(e, t, o, a, i) {
    var u = typeof e;
    "undefined" !== u && "boolean" !== u || (e = null);
    var c = !1;
    if (null === e) c = !0;else switch (u) {
      case "string":
      case "number":
        c = !0;
        break;

      case "object":
        switch (e.$$typeof) {
          case n:
          case r:
            c = !0;
        }

    }
    if (c) return i = i(c = e), e = "" === a ? "." + L(c, 0) : a, Array.isArray(i) ? (o = "", null != e && (o = e.replace(x, "$&/") + "/"), k(i, t, o, "", function (e) {
      return e;
    })) : null != i && (C(i) && (i = function (e, t) {
      return {
        $$typeof: n,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }(i, o + (!i.key || c && c.key === i.key ? "" : ("" + i.key).replace(x, "$&/") + "/") + e)), t.push(i)), 1;
    if (c = 0, a = "" === a ? "." : a + ":", Array.isArray(e)) for (var s = 0; s < e.length; s++) {
      var p = a + L(u = e[s], s);
      c += k(u, t, o, p, i);
    } else if ("function" == typeof (p = function (e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = l && e[l] || e["@@iterator"]) ? e : null;
    }(e))) for (e = p.call(e), s = 0; !(u = e.next()).done;) c += k(u = u.value, t, o, p = a + L(u, s++), i);else if ("object" === u) throw t = "" + e, Error(f(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
    return c;
  }

  function O(e, t, n) {
    if (null == e) return e;
    var r = [],
        o = 0;
    return k(e, r, "", "", function (e) {
      return t.call(n, e, o++);
    }), r;
  }

  function I(e) {
    if (-1 === e._status) {
      var t = e._result;
      t = t(), e._status = 0, e._result = t, t.then(function (t) {
        0 === e._status && (t = t.default, e._status = 1, e._result = t);
      }, function (t) {
        0 === e._status && (e._status = 2, e._result = t);
      });
    }

    if (1 === e._status) return e._result;
    throw e._result;
  }

  var N = {
    current: null
  };

  function E() {
    var e = N.current;
    if (null === e) throw Error(f(321));
    return e;
  }

  var D = {
    ReactCurrentDispatcher: N,
    ReactCurrentBatchConfig: {
      transition: 0
    },
    ReactCurrentOwner: b,
    IsSomeRendererActing: {
      current: !1
    },
    assign: p
  };
  t.Children = {
    map: O,
    forEach: function (e, t, n) {
      O(e, function () {
        t.apply(this, arguments);
      }, n);
    },
    count: function (e) {
      var t = 0;
      return O(e, function () {
        t++;
      }), t;
    },
    toArray: function (e) {
      return O(e, function (e) {
        return e;
      }) || [];
    },
    only: function (e) {
      if (!C(e)) throw Error(f(143));
      return e;
    }
  }, t.Component = m, t.PureComponent = h, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = D, t.cloneElement = function (e, t, r) {
    if (null == e) throw Error(f(267, e));
    var o = p({}, e.props),
        a = e.key,
        i = e.ref,
        u = e._owner;

    if (null != t) {
      if (void 0 !== t.ref && (i = t.ref, u = b.current), void 0 !== t.key && (a = "" + t.key), e.type && e.type.defaultProps) var c = e.type.defaultProps;

      for (s in t) j.call(t, s) && !M.hasOwnProperty(s) && (o[s] = void 0 === t[s] && void 0 !== c ? c[s] : t[s]);
    }

    var s = arguments.length - 2;
    if (1 === s) o.children = r;else if (1 < s) {
      c = Array(s);

      for (var l = 0; l < s; l++) c[l] = arguments[l + 2];

      o.children = c;
    }
    return {
      $$typeof: n,
      type: e.type,
      key: a,
      ref: i,
      props: o,
      _owner: u
    };
  }, t.createContext = function (e, t) {
    return void 0 === t && (t = null), (e = {
      $$typeof: a,
      _calculateChangedBits: t,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }).Provider = {
      $$typeof: o,
      _context: e
    }, e.Consumer = e;
  }, t.createElement = w, t.createFactory = function (e) {
    var t = w.bind(null, e);
    return t.type = e, t;
  }, t.createRef = function () {
    return {
      current: null
    };
  }, t.forwardRef = function (e) {
    return {
      $$typeof: i,
      render: e
    };
  }, t.isValidElement = C, t.lazy = function (e) {
    return {
      $$typeof: c,
      _payload: {
        _status: -1,
        _result: e
      },
      _init: I
    };
  }, t.memo = function (e, t) {
    return {
      $$typeof: u,
      type: e,
      compare: void 0 === t ? null : t
    };
  }, t.useCallback = function (e, t) {
    return E().useCallback(e, t);
  }, t.useContext = function (e, t) {
    return E().useContext(e, t);
  }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
    return E().useEffect(e, t);
  }, t.useImperativeHandle = function (e, t, n) {
    return E().useImperativeHandle(e, t, n);
  }, t.useLayoutEffect = function (e, t) {
    return E().useLayoutEffect(e, t);
  }, t.useMemo = function (e, t) {
    return E().useMemo(e, t);
  }, t.useReducer = function (e, t, n) {
    return E().useReducer(e, t, n);
  }, t.useRef = function (e) {
    return E().useRef(e);
  }, t.useState = function (e) {
    return E().useState(e);
  }, t.version = "17.0.1";
});
    u(function (e, t) {
});
    var m = u(function (e) {
  e.exports = d ;
}),
    g = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";

function C() {}

var x,
    L,
    k,
    O,
    I,
    N,
    E,
    D,
    S,
    _,
    T,
    z,
    P,
    R,
    A,
    $,
    B,
    F,
    Q = u(function (e) {
  e.exports = function () {
    function e(e, t, n, r, o, a) {
      if (a !== g) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = C, n.PropTypes = n, n;
  }();
}),
    Y = qe.div.attrs({
  className: "crystallize-dialog-legacy-backdrop"
})(x || (x = i(["\n  background: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n"]))),
    U = qe.div.attrs({
  className: "crystallize-dialog-outer"
})(L || (L = i(["\n  &[data-a11y-dialog-native] {\n    ", " {\n      display: none;\n    }\n  }\n\n  &:not([data-a11y-dialog-native]) {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9997;\n\n    dialog {\n      z-index: 9999;\n      position: relative;\n\n      &[open] {\n        display: block;\n      }\n    }\n\n    ", " {\n      z-index: 9998;\n    }\n  }\n"])), Y, Y),
    W = qe.dialog.attrs({
  className: function (e) {
    var t = ["crystallize-dialog"];
    return e.preShown && t.push(t[0] + "--pre-show"), e.shown && t.push(t[0] + "--show"), e.tiny && t.push(t[0] + "--tiny"), e.medium && t.push(t[0] + "--medium"), e.type && t.push(t[0] + "--" + e.type), t.join(" ");
  },
  "aria-labelledby": "crystallize-dialog-title"
})(k || (k = i(["\n  max-width: 80vw;\n  border: none;\n  padding: 0;\n  opacity: 0;\n  transform: scale(0.9);\n  transition: opacity ", "ms, transform ", "ms;\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), 100, 100, function (e) {
  return e.tiny ? "width: 250px;" : "";
}, function (e) {
  return e.medium ? "max-width: 500px;" : "";
}, function (e) {
  return e.revealed ? "opacity: 1;\n         transform: none;" : "";
}),
    V = qe.div.attrs({
  className: "crystallize-dialog-inner"
})(O || (O = i(["\n  background: #fff;\n  padding: 20px;\n  border: none;\n"]))),
    Z = qe.header.attrs({
  className: "crystallize-dialog-header"
})(I || (I = i(["\n  margin-bottom: 15px;\n"]))),
    H = qe.h1.attrs({
  id: "crystallize-dialog-title",
  className: "crystallize-dialog-title"
})(N || (N = i(["\n  margin: 0;\n"]))),
    G = qe.footer.attrs({
  className: "crystallize-dialog-buttons"
})(E || (E = i(["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  margin-top: 15px;\n\n  > :not(:first-child) {\n    margin-right: 15px;\n  }\n"]))),
    q = qe.button.attrs({
  className: "crystallize-dialog-button"
})(D || (D = i([""]))),
    J = qe.div.attrs({
  className: "crystallize-dialog-close-button-positioner"
})(S || (S = i(["\n  position: absolute;\n  right: -7px;\n  top: -7px;\n  z-index: 1;\n"]))),
    X = qe.button.attrs({
  className: "crystallize-dialog-close-button"
})(_ || (_ = i([""]))),
    K = function (e) {
  function t() {
    for (var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];

    return (t = e.call.apply(e, [this].concat(r)) || this).state = {
      revealed: !1
    }, t.reveal = function () {
      t.setState({
        revealed: !0
      });
    }, t;
  }

  r(t, e);
  var n = t.prototype;
  return n.componentDidMount = function () {
    var e = this;
    this.timeout = setTimeout(function () {
      return e.reveal();
    }, 100);
  }, n.componentWillUnmount = function () {
    clearTimeout(this.timeout);
  }, n.render = function () {
    var e = this.props,
        t = e.children,
        n = e.title,
        r = e.Heading;
    return m.createElement(W, {
      type: e.type,
      tiny: e.tiny,
      revealed: this.state.revealed
    }, m.createElement(V, null, e.showCloseButton && m.createElement(J, null, m.createElement(e.ButtonClose, {
      type: "button",
      "data-a11y-dialog-hide": !0,
      "aria-label": "Close this dialog window"
    }, "×")), n && m.createElement(Z, null, m.createElement(r, null, n)), t));
  }, t;
}(m.Component),
    ee = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }

  return r(t, e), t.prototype.render = function () {
    var e = this.props,
        t = e.state,
        r = e.hide,
        o = e.ButtonOk,
        i = a(e, ["state", "hide", "ButtonOk"]);
    return m.createElement(K, n({
      title: t.title,
      tiny: !0,
      type: "alert"
    }, i), t.body, m.createElement(G, null, m.createElement(o, {
      onClick: r
    }, "Ok")));
  }, t;
}(m.Component),
    te = function (e) {
  function t() {
    for (var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];

    return (t = e.call.apply(e, [this].concat(r)) || this).hideWithFeedbackOk = function () {
      return t.props.hideWithFeedback("ok");
    }, t.hideWithFeedbackCancel = function () {
      return t.props.hideWithFeedback("cancel");
    }, t;
  }

  return r(t, e), t.prototype.render = function () {
    var e = this.props,
        t = e.state,
        r = e.ButtonOk,
        o = e.ButtonCancel,
        i = a(e, ["state", "ButtonOk", "ButtonCancel"]),
        u = t.body,
        c = t.buttons,
        s = void 0 === c ? {} : c,
        l = r,
        f = "Ok";
    s.ok && ("string" == typeof s.ok ? f = s.ok : l = s.ok);
    var p = o,
        d = "Cancel";
    return s.cancel && ("string" == typeof s.cancel ? d = s.cancel : p = s.cancel), m.createElement(K, n({
      title: t.title,
      type: "confirm"
    }, i), u, m.createElement(G, null, m.createElement(l, {
      onClick: this.hideWithFeedbackOk
    }, f), m.createElement(p, {
      onClick: this.hideWithFeedbackCancel
    }, d)));
  }, t;
}(m.Component),
    ne = function (e) {
  var t = e.state,
      r = a(e, ["state"]),
      o = t.body;
  return m.createElement(K, n({
    title: t.title,
    showCloseButton: t.showCloseButton,
    type: "dialog"
  }, r), o);
},
    re = qe.button(T || (T = i(["\n  appearance: none;\n  margin: 0;\n  font-weight: 400;\n  font-size: 16px;\n  padding: 8px 10px;\n  border: none;\n  cursor: pointer;\n  border-radius: 15px;\n\n  &:active {\n    transform: scale(0.9);\n  }\n"]))),
    oe = qe.h1(z || (z = i([""]))),
    ae = qe(re)(P || (P = i(["\n  background: #555;\n  color: #fff;\n\n  &:hover,\n  &:active {\n    background: #666;\n  }\n"]))),
    ie = qe(re)(R || (R = i(["\n  background: #f0f0f0;\n\n  &:hover,\n  &:active {\n    background: #ddd;\n  }\n"]))),
    ue = qe(re)(A || (A = i(["\n  color: #555;\n  background: transparent;\n  font-weight: 400;\n  font-size: 20px;\n  padding: 4px 6px;\n"]))),
    ce = qe.div($ || ($ = i(["\n  .crystallize-dialog {\n    min-width: 300px;\n    position: relative;\n\n    ", "  {\n      font-size: 20px;\n    }\n\n    &-inner {\n      padding: 40px 30px 20px 30px;\n      color: ", ";\n    }\n\n    &-close-button-positioner {\n      right: 0;\n      top: 0;\n    }\n\n    &--confirm,\n    &--alert {\n      padding-left: ", ";\n\n      &:before {\n        width: ", ';\n        height: 100%;\n        left: 0;\n        top: 0;\n        content: "";\n        position: absolute;\n        background: ', ';\n      }\n\n      &:after {\n        content: "";\n        width: ', ";\n        height: 100%;\n        left: 0;\n        top: 0;\n        position: absolute;\n        background-size: 70px;\n        background-repeat: no-repeat;\n        background-position: center;\n        opacity: 0.7;\n      }\n    }\n\n    &--confirm:after {\n      background-image: ", ";\n    }\n    &--alert:after {\n      background-image: ", ";\n    }\n\n    &--dialog {\n      min-height: 100px;\n\n      .crystallize-dialog-inner {\n        padding: 30px;\n        min-height: 40px;\n      }\n    }\n  }\n  .crystallize-dialog-buttons {\n    padding-top: 20px;\n  }\n"])), oe, "#000", "150px", "150px", "#eee", "150px", "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjgxLjQ4OCAyODEuNDg4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyODEuNDg4IDI4MS40ODg7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPjxnPjxwYXRoIGQ9Ik0xNDAuNzQ0LDBDNjMuMTM4LDAsMCw2My4xMzgsMCwxNDAuNzQ0czYzLjEzOCwxNDAuNzQ0LDE0MC43NDQsMTQwLjc0NHMxNDAuNzQ0LTYzLjEzOCwxNDAuNzQ0LTE0MC43NDQgICBTMjE4LjM1MSwwLDE0MC43NDQsMHogTTE0MC43NDQsMjYzLjQ4OEM3My4wNjMsMjYzLjQ4OCwxOCwyMDguNDI2LDE4LDE0MC43NDRTNzMuMDYzLDE4LDE0MC43NDQsMTggICBzMTIyLjc0NCw1NS4wNjMsMTIyLjc0NCwxMjIuNzQ0UzIwOC40MjUsMjYzLjQ4OCwxNDAuNzQ0LDI2My40ODh6IiBmaWxsPSIjMGZiY2Y5Ii8+PHBhdGggZD0iTTE2My4zNzQsMTgxLjc2NWwtMTYuODI0LDkuODQ5di03MS43OTFjMC0zLjE0My0xLjY0LTYuMDU4LTQuMzI1LTcuNjljLTIuNjg2LTEuNjMyLTYuMDI3LTEuNzQ3LTguODE4LTAuMjk5ICAgbC0yMy45ODEsMTIuNDM2Yy00LjQxMywyLjI4OC02LjEzNSw3LjcyLTMuODQ3LDEyLjEzMmMyLjI4OSw0LjQxMyw3LjcyLDYuMTM2LDEyLjEzMywzLjg0N2wxMC44MzgtNS42MnY3Mi42ODQgICBjMCwzLjIyNSwxLjcyNiw2LjIwMyw0LjUyMyw3LjgwOGMxLjM4NywwLjc5NSwyLjkzMiwxLjE5Miw0LjQ3NywxLjE5MmMxLjU3MiwwLDMuMTQzLTAuNDExLDQuNTQ2LTEuMjMybDMwLjM3MS0xNy43NzggICBjNC4yOS0yLjUxMiw1LjczMi04LjAyNCwzLjIyMS0xMi4zMTRTMTY3LjY2MywxNzkuMjU1LDE2My4zNzQsMTgxLjc2NXoiIGZpbGw9IiMwZmJjZjkiLz48Y2lyY2xlIGN4PSIxMzcuNTQ5IiBjeT0iODYuNjEyIiByPSIxMi40MzUiIGZpbGw9IiMwZmJjZjkiLz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+)", "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMjk0Ljk1MSAyOTQuOTUxIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyOTQuOTUxIDI5NC45NTEiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+ICA8Zz4gICAgPGc+ICAgICAgPHBhdGggZD0ibTE0Ny40NzUsMTAzLjEwMmMtNS4yMiwwLTguNzAxLDMuNDgtOC43MDEsOC43MDF2NjIuNjQ0YzAsNS4yMiAzLjQ4LDguNzAxIDguNzAxLDguNzAxIDUuMjIsMCA4LjcwMS0zLjQ4IDguNzAxLTguNzAxdi02Mi42NDRjMC01LjIyMS0zLjQ4MS04LjcwMS04LjcwMS04LjcwMXoiIGZpbGw9IiNlZjQ4MzYiLz4gICAgICA8cGF0aCBkPSJtMTUyLjY5NSwyMTIuNzNjLTMuNDgtMy40OC04LjcwMS0zLjQ4LTEyLjE4MSwwLTEuNzQsMS43NC0xLjc0LDUuMjItMS43NCw2Ljk2IDAsMy40OCAwLDUuMjIgMS43NCw2Ljk2IDEuNzQsMS43NCA1LjIyLDEuNzQgNi45NiwxLjc0IDEuNzQsMCA1LjIyLDAgMy40OC0xLjc0IDEuNzQtMS43NCAzLjQ4LTUuMjIgMy40OC02Ljk2IDAuMDAyLTMuNDggMC4wMDItNS4yMi0xLjczOS02Ljk2eiIgZmlsbD0iI2VmNDgzNiIvPiAgICAgIDxwYXRoIGQ9Im0yODguNDI1LDIxNC40N2wtMTAyLjY2Ny0xNzkuMjMyYy02Ljk2LTEzLjkyMS0yMi42MjEtMjIuNjIxLTM4LjI4My0yMi42MjEtMTUuNjYxLDAtMjkuNTgyLDguNzAxLTM4LjI4MywyMi42MjFsLTEwMi42NjcsMTc5LjIzMmMtOC43MDEsMTMuOTIxLTguNzAxLDMxLjMyMi01LjMyOTA3ZS0xNSw0NS4yNDMgNi45NiwxMy45MjEgMjIuNjIxLDIyLjYyMSAzOC4yODMsMjIuNjIxaDIwNS4zMzRjMTcuNDAxLDAgMzEuMzIyLTguNzAxIDM4LjI4My0yMi42MjEgOC43MDEtMTMuOTIxIDguNzAxLTMxLjMyMiAwLTQ1LjI0M3ptLTEzLjkyMSwzOC4yODNjLTMuNDgsOC43MDEtMTIuMTgxLDEzLjkyMS0yMi42MjEsMTMuOTIxaC0yMDcuMDc1Yy04LjcwMSwwLTE3LjQwMS01LjIyLTIyLjYyMS0xMy45MjEtNS4yMi04LjcwMS01LjIyLTE5LjE0MSAwLTI3Ljg0MmwxMDIuNjY3LTE3OS4yMzNjMy40OC04LjcwMSAxMi4xODEtMTMuOTIxIDIyLjYyMS0xMy45MjEgMTAuNDQxLDAgMTkuMTQxLDUuMjIgMjQuMzYyLDEzLjkyMWwxMDIuNjY3LDE3OS4yMzJjNS4yMjEsOC43MDEgNS4yMjEsMTkuMTQyIDAsMjcuODQzeiIgZmlsbD0iI2VmNDgzNiIvPiAgICA8L2c+ICA8L2c+PC9zdmc+)");

function se(e, t) {
  if (!B) return Promise.resolve();
  var r = {
    title: null,
    body: t,
    buttons: {},
    showCloseButton: "dialog" === e
  };
  return "string" != typeof t && Object.assign(r, t), new Promise(function (t) {
    B(n({}, r, {
      type: e,
      resolve: t
    }));
  });
}

function le(e) {
  return se("alert", e);
}

function fe(e) {
  return se("confirm", e);
}

function pe(e) {
  return se("dialog", e);
}

function de() {
  F && F();
}

var ye = function (t) {
  function n() {
    for (var n, r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];

    return (n = t.call.apply(t, [this].concat(o)) || this).state = {
      current: null,
      queue: [],
      shown: !1,
      feedback: null
    }, n.onAdd = function (e) {
      var t = n.state;
      t.current ? n.setState({
        queue: [].concat(t.queue, [e])
      }) : n.setState({
        current: e
      }, n.show);
    }, n.show = function () {
      n.state.current && (n.dialog = new a11yDialog(n.el), n.dialog.on("hide", n.onHideFromDialog), n.dialog.show(), n.suspendClose = !0, n.suspendCloseTimeout = setTimeout(function () {
        return n.suspendClose = !1;
      }, 300));
    }, n.hide = function () {
      n.state.current && !n.suspendClose && n.dialog.hide();
    }, n.hideWithFeedback = function (e) {
      n.setState({
        feedback: e
      }, function () {
        return n.hide();
      });
    }, n.onHideFromDialog = function () {
      n.onHide("confirm" === n.state.current.type ? "cancel" : n.state.feedback, !0);
    }, n.onHide = function (e, t) {
      void 0 === e && (e = n.state.feedback), n.state.current.resolve(e), t || n.dialog.destroy();
      var r = null,
          o = [].concat(n.state.queue);
      o.length && (r = o.shift()), n.setState({
        current: r,
        queue: o,
        feedback: null
      }, n.show);
    }, n.onDialogChange = function (e) {
      return n.setState({
        feedback: e
      });
    }, n.hideWithFeedback = function (e) {
      return n.onHide(e);
    }, n.getRef = function (e) {
      return n.el = e;
    }, n.onClick = function (e) {
      n.state.current.disableBackdropClick || "confirm" === n.state.current.type || ("DIALOG" === e.target.tagName || e.target.classList.contains("crystallize-dialog-legacy-backdrop")) && (n.hide(), e.preventDefault());
    }, n;
  }

  r(n, t), n.getDerivedStateFromProps = function (e) {
    var t = e.cleanTheme,
        n = {};
    return n.ButtonOk = e.ButtonOk || (t ? q : ae), n.ButtonCancel = e.ButtonCancel || (t ? q : ie), n.ButtonClose = e.ButtonClose || (t ? X : ue), n.Heading = e.Heading || (t ? H : oe), n;
  };
  var o = n.prototype;
  return o.componentDidCatch = function (e, t) {
    console.log(e, t);
  }, o.componentDidMount = function () {
    B = this.onAdd, F = this.hide, this.unsubscribe = function () {
      B = null, F = null;
    };
  }, o.componentWillUnmount = function () {
    this.unsubscribe && this.unsubscribe(), clearTimeout(this.suspendCloseTimeout);
  }, o.getCurrentComponent = function () {
    var e = this.state,
        t = e.current;
    if (!t) return null;
    var n = {
      state: t,
      hide: this.hide,
      hideWithFeedback: this.hideWithFeedback,
      ButtonOk: e.ButtonOk,
      ButtonCancel: e.ButtonCancel,
      Heading: e.Heading,
      ButtonClose: e.ButtonClose
    };

    switch (t.type) {
      case "alert":
        return m.createElement(ee, n);

      case "confirm":
        return m.createElement(te, n);

      case "dialog":
        return m.createElement(ne, n);

      default:
        return null;
    }
  }, o.render = function () {
    var e = this.props.cleanTheme,
        t = this.getCurrentComponent();
    if (!t) return null;
    var n = m.createElement(U, {
      ref: this.getRef,
      onClick: this.onClick
    }, m.createElement(Y, {
      tabIndex: "-1",
      onClick: this.onClick
    }), t);
    return e ? n : m.createElement(ce, null, n);
  }, n;
}(m.PureComponent);

ye.propTypes = {
  cleanTheme: Q.bool,
  ButtonOk: Q.oneOfType([Q.func, Q.object, Q.node]),
  ButtonCancel: Q.oneOfType([Q.func, Q.object, Q.node]),
  ButtonClose: Q.oneOfType([Q.func, Q.object, Q.node]),
  Heading: Q.oneOfType([Q.func, Q.object, Q.node])
};
var me = ye;

export { me as Wrapper, de as closeCurrent, le as showAlert, fe as showConfirm, pe as showDialog };
